import React, { useEffect, useRef, useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/pt-br";

import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  makeStyles,
} from "@material-ui/core";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

moment.locale("pt-br");

const useStyles = makeStyles(() => ({
  input: {
    padding: "10.5px 14px",
    borderRadius: 8,
    backgroundColor: "#f9f9fb",
    fontSize: "14px",
    width: "100%",
    "&:focus": {
      outline: "none",
    },
  },
  root: {
    backgroundColor: "#f9f9fb",
    borderRadius: 8,
    border: "1px solid #6c757d",
    "&:hover": {
      borderColor: "#bdbdbd",
    },
    "& .MuiInputBase-root": {
      paddingRight: 0,
    },
  },
  labelHidden: {
    display: "none",
  },
  labelStatic: {
    position: "absolute",
    marginLeft: "12px",
    zIndex: 1,
    top: 8,
    fontSize: "14px",
    color: "#757575",
    transition: "all 0.2s ease",
  },
    erroStatus: {
    position: "relative",
    "&::after": {
      position: "absolute",
      content: '"Adicione a data."',
      color: "#dc3545",
      fontSize: "12px",
      right: 0,
      bottom: -20,
    },
  },
}));
const CustomInput = forwardRef(
  ({ value, onClick, onChange, label, disabled, error }, ref) => {
    const classes = useStyles();
    const [focused, setFocused] = useState(false);

    const showLabel =
      !focused && (!value || value.trim() === "");

    return (
      <Box position="relative">
        {showLabel && (
          <label className={classes.labelStatic}>{label}</label>
        )}
        <TextField
          className={error ? classes.erroStatus : ""}
          fullWidth
          value={value}
          onClick={onClick}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          InputLabelProps={{ shrink: false }}
          disabled={disabled}
          InputProps={{
            classes: { input: classes.input, root: classes.root },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={onClick}>
                  <CalendarTodayIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    );
  }
);
export const AbsolutePeriod = ({
  defaultStartDate = null,
  defaultEndDate = null,
  value,
  onChange,
  error = false
}) => {
  const [startDate, setStartDate] = useState(
    defaultStartDate ? new Date(defaultStartDate) : null
  );
  const [endDate, setEndDate] = useState(
    defaultEndDate ? new Date(defaultEndDate) : null
  );

  const [inputStart, setInputStart] = useState("");
  const [inputEnd, setInputEnd] = useState("");

  const [isTypingStart, setIsTypingStart] = useState(false);
  const [isTypingEnd, setIsTypingEnd] = useState(false);

  const initializedRef = useRef(false);

  useEffect(() => {
    if (value && !initializedRef.current) {
      const { start, end } = value;
      const s = start ? new Date(start + "T00:00:00") : null;
      const e = end ? new Date(end + "T00:00:00") : null;

      setStartDate(s);
      setEndDate(e);
      setInputStart(s ? moment(s).format("DD/MM/YYYY") : "");
      setInputEnd(e ? moment(e).format("DD/MM/YYYY") : "");

      initializedRef.current = true;
    }
  }, [value]);

  useEffect(() => {
    if (onChange) {
      onChange({
        start: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
        end: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
      });
    }
  }, [startDate, endDate]);

  const handleRawChangeStart = (e) => {
    const val = e.target.value;
    setInputStart(val);
    setIsTypingStart(true);

    const date = moment(val, "DD/MM/YYYY", true);
    if (date.isValid()) {
      setStartDate(date.toDate());
      setIsTypingStart(false);
    } else if (val === "") {
      setStartDate(null);
    }
  };

  const handleRawChangeEnd = (e) => {
    const val = e.target.value;
    setInputEnd(val);
    setIsTypingEnd(true);

    const date = moment(val, "DD/MM/YYYY", true);
    if (date.isValid()) {
      setEndDate(date.toDate());
      setIsTypingEnd(false);
    } else if (val === "") {
      setEndDate(null);
    }
  };

  const handleCalendarChangeStart = (date) => {
    if (!isTypingStart) {
      setStartDate(date);
      setInputStart(date ? moment(date).format("DD/MM/YYYY") : "");
      setIsTypingStart(false);
    }

  };

  const handleCalendarChangeEnd = (date) => {
    if (!isTypingEnd) {
      setEndDate(date);
      setInputEnd(date ? moment(date).format("DD/MM/YYYY") : "");
      setIsTypingEnd(false);

    }
  };

  return (
    <Box display="flex" style={{ gap: "1rem" }}>
      <DatePicker
        selected={startDate}
        onChange={handleCalendarChangeStart}
        onChangeRaw={handleRawChangeStart}
        onCalendarClose={() => setIsTypingStart(false)}
        portalId="blockRules"
        dateFormat="dd/MM/yyyy"
        locale="pt-BR"
        customInput={
          <CustomInput
            error={!startDate && error}
            label="Data início"
            onChange={handleRawChangeStart}
            value={inputStart}
          />
        }
      />
      <DatePicker
        selected={endDate}
        onChange={handleCalendarChangeEnd}
        onChangeRaw={handleRawChangeEnd}
         onCalendarClose={() => setIsTypingEnd(false)}
       portalId="blockRules"
        dateFormat="dd/MM/yyyy"
        locale="pt-BR"
        minDate={startDate}
        disabled={!startDate}
        customInput={
          <CustomInput
           error={!endDate && error}
            disabled={!startDate}
            label = {'Data fim'}
            onChange={handleRawChangeEnd}
            value={inputEnd}
          />
        }
      />
    </Box>
  );
};

